









































import { Component, Vue, Watch } from "vue-property-decorator";
import { authModule, jimizzModule, metamaskModule } from "@/store";
import Card from "@/components/ui/card/Card.vue";
import { round } from "@/helpers/round.helper";
import Loader from "@/components/ui/Loader.vue";

@Component({
  components: { Loader, Card },
})
export default class DashboardBalance extends Vue {
  fetchingBalance = false;
  fetchingStakingBalance = false;

  get account(): string {
    return metamaskModule.account ?? "";
  }

  get shortAccount(): string {
    return [
      this.account.substring(0, 11),
      this.account.substring(this.account.length - 4),
    ].join("...");
  }

  get balance(): number {
    const balance = jimizzModule.balance;
    return round(balance);
  }

  get totalBalance(): number {
    return round(jimizzModule.totalBalance);
  }

  get fetching(): boolean {
    return this.fetchingBalance || this.fetchingStakingBalance;
  }

  async mounted(): Promise<void> {
    await Promise.all([this.refreshBalance(), this.refreshStakingBalance()]);
  }

  async refreshBalance(): Promise<void> {
    try {
      this.fetchingBalance = true;
      await jimizzModule.fetchWalletBalance();
      this.fetchingBalance = false;
    } catch (e) {
      // TODO: display error
      console.log(e);
    }
  }

  async refreshStakingBalance(): Promise<void> {
    try {
      this.fetchingStakingBalance = true;
      await jimizzModule.fetchStakingBalance();
      this.fetchingStakingBalance = false;
    } catch (e) {
      // TODO: display error
      console.log(e);
    }
  }

  async connect(): Promise<void> {
    await authModule.login();
  }

  @Watch("account")
  onAccountChanged() {
    this.refreshBalance();
    this.refreshStakingBalance();
  }
}
